export type SupportedFileType = 'pdf' | 'docx' | 'doc' | 'txt' | 'image' | 'excel' | 'unsupported' | 'unknown';

export interface DocumentViewerConfig {
  fileName: string;
  fileUrl?: string;
  fileBlob?: Blob;
  fileType: SupportedFileType;
  showToolbar?: boolean;
  allowDownload?: boolean;
  allowPrint?: boolean;
}

export interface DocumentViewerOptions {
  // PDF specific options
  pdfZoom?: number | 'auto';
  pdfShowSidebar?: boolean;

  // DOCX specific options
  docxClassName?: string;
  docxInWrapper?: boolean;
  docxIgnoreWidth?: boolean;
  docxIgnoreHeight?: boolean;

  // TXT specific options
  txtSyntaxHighlight?: boolean;
  txtLineNumbers?: boolean;
}

export enum DocumentStatus {
  LOADING = 'loading',
  LOADED = 'loaded',
  ERROR = 'error',
  RENDERING = 'rendering',
  READY = 'ready'
}
